module.exports = __webpack_public_path__ + "static/img/newStock1.56cabbe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/works/newStock/newStock1.jpg
// module id = eQlm
// module chunks = 1